import { cn } from '@/lib/utils'
import type { AgentStatus, AgentVillageStatus } from '../types'
import { formatRelativeTime } from '../services/agent-village-service'

interface AgentStatusBadgeProps {
  status: AgentVillageStatus | undefined
  onTimelineClick?: () => void // D-01: badge click navigates to lifecycle timeline
}

const STATUS_COLORS: Record<AgentStatus, string> = {
  active: 'bg-primary',
  idle: 'bg-yellow-500',
  error: 'bg-red-500',
  offline: 'bg-muted-foreground/40',
}

export function AgentStatusBadge({ status, onTimelineClick }: AgentStatusBadgeProps) {
  if (!status) return null

  return (
    <button
      onClick={(e) => {
        e.stopPropagation()
        onTimelineClick?.()
      }}
      className="flex items-center gap-1.5 group/badge"
      aria-label={`Agent ${status.status}. ${status.last_action ? `Last action: ${status.last_action}` : ''}`}
      title="Open Agent Timeline"
    >
      <span
        className={cn(
          'w-2 h-2 rounded-full transition-colors duration-300',
          STATUS_COLORS[status.status],
        )}
      />
    </button>
  )
}
